import type { IChangeFilterItems } from "app/components/filters-bar/change-filter/ChangeFilter";
import { EChangeFilterValues } from "app/components/filters-bar/change-filter/ChangeFilter";

export const changeFilterItems: IChangeFilterItems[] = [
    {
        text: "change.filter.trending",
        id: EChangeFilterValues.Trending,
        tooltip: "change.filter.trending.tooltip",
    },
    {
        text: "change.filter.de-trending",
        id: EChangeFilterValues.DeTrending,
        tooltip: "change.filter.detrending.tooltip",
    },
    {
        text: "change.filter.lost-clicks",
        id: EChangeFilterValues.LostClicks,
        tooltip: "change.filter.lost.tooltip",
    },
    {
        text: "change.filter.new-clicks",
        id: EChangeFilterValues.NewClicks,
        tooltip: "change.filter.new.tooltip",
    },
];
